import { store } from 'app/store';
import axios from 'axios';
import { AirportsInterface, publicTiers } from 'store/publicData/publicData.interface';
import urls from 'utils/urls';

export const getPublicTiersDataService: () => Promise<{ data: publicTiers[] }> = () => {
  try {
    const state = store.getState();
    const publicTiers = state.publicData.publicTiers.data;
    if (publicTiers) {
      return Promise.resolve({ data: publicTiers });
    } else {
      return axios
        .get(urls.publiceTiers, { baseURL: `${process.env.REACT_APP_BASEURL}/api/v1` })
        .then((res) => {
          return { data: res.data.response as publicTiers[] };
        })
        .catch((err) => {
          throw err;
        });
    }
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const getDeparturAirportService: () => Promise<{ data: AirportsInterface[] }> = () => {
  try {
    const state = store.getState();
    const departurAirports = state.publicData.departureLocationsRoute.data;

    if (departurAirports) {
      return Promise.resolve({ data: departurAirports });
    } else {
      return axios
        .get(urls.departureLocationsRoute)
        .then((res) => {
          return { data: res.data.response as AirportsInterface[] };
        })
        .catch((err) => {
          throw err;
        });
    }
  } catch (ex) {
    return Promise.reject(ex);
  }
};
